import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	descriptionHeader: {
		id: 'software-releases-version-summary-description.description-header',
		defaultMessage: 'Description',
		description: 'Text for he header of the version description field',
	},
});
